export default "__VITE_ASSET__dcdf9641__"